import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IAppState } from "../../state/app.state";
import { IGeneralSelectionState } from "../../state/general-selection.state";

export const getGeneralSelectionState = createFeatureSelector<IAppState, IGeneralSelectionState>('generalSelection');

export const selectGeneralSelectionBaseUrl = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.baseUrl
);

export const selectGeneralSelectionDate = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.toDate
);

export const selectGeneralSelectionDateInitialised = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.dataInitalised
);

export const selectGeneralSelectionSelectedCurrency = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.selectedCurrency
);

export const selectGeneralSelectionSelectedEntities = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.selectedEntities
);

export const selectGeneralSelectionSelectedPortfolios = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.selectedPortfolios
);

export const selectGeneralSelectionClientTitle = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.clientTitle
);

export const selectGeneralSelectionSelectedClient = createSelector(
    getGeneralSelectionState,
    (state: IGeneralSelectionState) => state.selectedClient
);
